var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 3.97998H23.75V20.02H0.25V3.97998Z",
    fill: "#F4F6F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 3.97998H23.75V8.84998H0.25V3.97998Z",
    fill: "#F58445"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 15.1499H23.75V20.0199H0.25V15.1499Z",
    fill: "#59BF59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 9.5498C10.6498 9.5498 9.5498 10.6498 9.5498 11.9998C9.5498 13.3498 10.6498 14.4498 11.9998 14.4498C13.3498 14.4498 14.4498 13.3498 14.4498 11.9998C14.4498 10.6498 13.3498 9.5498 11.9998 9.5498ZM12.2548 10.0848C12.5998 10.1298 12.9098 10.2648 13.1748 10.4648L12.2548 11.3848V10.0848ZM11.7448 11.3848L10.8248 10.4648C11.0848 10.2648 11.3998 10.1298 11.7448 10.0848V11.3848ZM11.3848 11.7448H10.0898C10.1348 11.3998 10.2698 11.0898 10.4698 10.8298L11.3848 11.7448ZM11.3848 12.2548L10.4648 13.1748C10.2648 12.9098 10.1298 12.5998 10.0848 12.2548H11.3848ZM11.7448 12.6148V13.9148C11.3998 13.8698 11.0898 13.7348 10.8248 13.5348L11.7448 12.6148ZM12.2548 12.6148L13.1748 13.5348C12.9148 13.7348 12.5998 13.8698 12.2548 13.9148V12.6148ZM12.6148 12.2548H13.9148C13.8698 12.5998 13.7348 12.9098 13.5348 13.1748L12.6148 12.2548ZM12.6148 11.7448L13.5348 10.8248C13.7348 11.0848 13.8698 11.3998 13.9148 11.7448H12.6148Z",
    fill: "#289BC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.3a8bac2d8cea621b53d360b978b272ea.svg";
export { ForwardRef as ReactComponent };